/* lib-components-image-map.modules.ts */
import { NgModule } from '@angular/core';


import { PinchZoomComponent } from '@meddv/ngx-pinch-zoom';


// img-map
import { ImageMapComponent } from './feature/image-map/image-map.component' 



// --------------

@NgModule({
  declarations: [

  ],
  imports: [
    PinchZoomComponent,
    ImageMapComponent

  ],
  exports: [
    PinchZoomComponent,
    ImageMapComponent

  ]
})
export class LibComponentsImageMapModule {}
